'use strict';

// hide close button for the bookmarklet login (loaded in iFrame)

import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  if (window !== window.top) {
    $('.auth-close-link').hide();
    $('.login-form__lost-password-link').hide();
    $('#login').css('overflow', 'auto');
  }

  $(document).on('submit', '.login-form, .xhr-login-form', (e) => {
    const $form = $(e.target);
    // name-based lookup: the client login form namespaces its field ids
    const email = $form.find('input[name="user[email]"]').val();
    const password = $form.find('input[name="user[password]"]').val();
    const $submit = $form.find('button[type=submit]');

    if (!email || !password) {
      return false;
    }

    $submit.addClass('button-loading').prop('disabled', true);

    if ($form.is('.login-form')) {
      return true;
    } else if ($form.is('.xhr-login-form')) {
      const data = $('.xhr-login-form input')
        .get()
        .reduce((map, el) => ((map[el.name] = el.value), map), {});

      $.post(
        $form.attr('action'),
        data,
        (_res) => {
          $('.project-form').submit();
        },
        'json'
      ).fail(() => {
        alert('Error. Could not create new account.');
        $submit.removeClass('button-loading').prop('disabled', false);
      });
    }

    return false;
  });

  if ($('body').is('#login')) {
    if ($('.flash--login').length) {
      const flashText = $('.flash--login').text();
      $('.form-error--invalid-email-or-password').show().text(flashText);
    }
  }
});
